import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { OrganizationTypeSelectionComponent } from './organization-type-selection.component';
import { RouterLinkStubDirective } from 'helpers/test/stubs/router-link.directive';
import { FcpLinkModule } from 'fc-ui-components';

@NgModule({
    declarations: [OrganizationTypeSelectionComponent, RouterLinkStubDirective],
    imports: [TranslateModule, CommonModule, RouterModule, FcpLinkModule],
    exports: [OrganizationTypeSelectionComponent]
})
export class OrganizationTypeSelectionModule {}
